namespace TabAurous.Common {
    export enum IntegrationType {
        Communications = 1,
        MarketPlace = 2,
        PaymentGateway = 3
    }
    Serenity.Decorators.registerEnumType(IntegrationType, 'TabAurous.Common.IntegrationType', 'Administration.IntegrationType');
}
